import React from 'react';
import useIsMobile from '../../shared/hooks/useIsMobile';
import { useNews } from '../../context/NewsContext';
import { useDevelopmentEngines, defaultDevelopmentEngines } from '../../context/DevelopmentEnginesContext';
import { useImpact } from '../../context/ImpactContext';
import HomeMobile from './Home.mobile';
import HomeDesktop from './Home.desktop';

const HomeFeature = ({ showImpactSection = true }) => {
  const isMobile = useIsMobile();
  const { publishedNews } = useNews();
  const { enginesData } = useDevelopmentEngines();
  const { impactData } = useImpact();
  const View = isMobile ? HomeMobile : HomeDesktop;

  const engines = Array.isArray(enginesData?.engines) && enginesData.engines.length
    ? enginesData.engines
    : defaultDevelopmentEngines.engines;

  return (
    <View
      showImpactSection={showImpactSection}
      news={publishedNews || []}
      engines={engines}
      impactData={impactData}
      enginesTitle={enginesData?.sectionTitle || defaultDevelopmentEngines.sectionTitle}
    />
  );
};

export default HomeFeature;
